import { accountApi } from "../../config/apiConfig";
import { EichrechtVerdict } from "../../types/onboarding";

export interface EichrechtDecisionPayload {
  manufacturer: string;
  model: string;
  verdict: EichrechtVerdict;
  note: string;
}

// The customers that entered a model, for links to their prospects.
export interface EichrechtProspectRef {
  id: string;
  name: string;
  current_state: string;
}

export interface EichrechtDecisionEntry {
  verdict: EichrechtVerdict;
  note: string;
  decided_by: string;
  decided_at: string;
}

export interface EichrechtDecisionView extends EichrechtDecisionEntry {
  model_key: string;
  manufacturer: string;
  model: string;
  // Earlier decisions for the model, newest first.
  history: EichrechtDecisionEntry[];
  prospects: EichrechtProspectRef[];
}

export interface PendingEichrechtModel {
  model_key: string;
  manufacturer: string;
  model: string;
  prospects: EichrechtProspectRef[];
}

export interface EichrechtOverview {
  decisions: EichrechtDecisionView[];
  pending: PendingEichrechtModel[];
}

// PUT /admin/eichrecht-decisions — support's decision for a wallbox model,
// reused for every customer with it (CWA-230). 400 for a missing note.
export const decideEichrecht = async (payload: EichrechtDecisionPayload): Promise<void> => {
  await accountApi.put("admin/eichrecht-decisions", payload);
};

// GET /admin/eichrecht-decisions — every decision with its customers, and the
// models still waiting for a check with the customers they hold back (SOPS-195).
export const listEichrechtDecisions = async (): Promise<EichrechtOverview> => {
  const response = await accountApi.get("admin/eichrecht-decisions");
  return {
    decisions: response.data?.decisions ?? [],
    pending: response.data?.pending ?? [],
  };
};
